module.exports = __webpack_public_path__ + "img/pr-3.7f6c3e8f.png";